
import React from 'react'
import PropTypes from 'prop-types';
import {Radio, RadioGroup} from "@blueprintjs/core";

class EditorBooleano extends React.Component {

    constructor(props) {
        super(props)

        let campo= props.editorExternoColumn.campo;
        let valorInicial= props.editorExternoObjeto[campo] ? Number(props.editorExternoObjeto[campo]) : 0;

        this.state = {
            valor: valorInicial,
            campo: campo,
            valorOriginal: valorInicial,
        }

    }


    changeValor= (newValor) => {
        const {valorOriginal} = this.state;
        const {onCloseEditor, gridRDG, editorExternoColumn, editorExternoObjeto} = this.props;

        console.log("EditorLista - changeValor");
        console.log("editorExternoColumn: ", editorExternoColumn.editorExterno);
        if (editorExternoColumn.editorExterno.onCambioPermitido) {
            let oResultadoCambioPermitido= editorExternoColumn.editorExterno.onCambioPermitido(valorOriginal, newValor, editorExternoObjeto);
            if (!oResultadoCambioPermitido.exito) {
                alert (oResultadoCambioPermitido.mensaje);
                this.setState({valor: valorOriginal});
            } else {
                this.setState({valor: newValor}, () => {
                        onCloseEditor && onCloseEditor(newValor)
                    }
                );
            }
        }
        else{
            this.setState({valor: newValor}, () => {
                    onCloseEditor && onCloseEditor(newValor)
                }
            );
        }
    }

    render() {
        const {valor} = this.state;
        const {editorExternoColumn} = this.props;
        let titulo= "Seleccione una opción de " + editorExternoColumn.titulo.toUpperCase();
        return (
            <RadioGroup
                label={titulo}
                onChange={(event) => this.changeValor(event.target.value)}
                selectedValue={valor}
            >
                <Radio key="rSi" label="Sí" value={true} />
                <Radio key="rNo" label="No" value={false} />
            </RadioGroup>
        )

    }

}


EditorBooleano.propTypes = {
    gridRDG: PropTypes.object,
    editorExternoColumn: PropTypes.object,
    editorExternoObjeto: PropTypes.object,
    onCloseEditor: PropTypes.func,
}

export default EditorBooleano;